import styled from "styled-components";
import {
  StepConnector,
  stepConnectorClasses,
  TextField as TextFieldMaterialUI,
} from "@mui/material";

export const CustomConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 22,
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: `#BDBDBD`,
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderColor: `#BDBDBD`,
    borderTopWidth: 1,
    borderRadius: 1,
  },
}));

export const TextField = styled(TextFieldMaterialUI)`
  flex: 1 1 calc((100% - 260px) / 4);
  min-width: 260px;
`;

export const Container = styled.div`
  width: 100%;
  border: solid 1px #0000003B;
  border-radius: 16px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const Flex = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const Key = styled.span`
  font-size: 14px;
  font-weight: 400;
  line-height: 166%;
  color: #0F0F1E99;
`;

export const Value = styled.span`
  font-size: 14px;
  font-weight: 500;
  line-height: 143%;
  color: #0F0F1E99;
  text-align: right;
`;